/**
 * @description 對象年齡類型 (enum)
 */
export enum TargetAgeTypesEnum {
  /** 一般年齡 */
  AD = 'AD',
  /** 七歲以下 */
  U7 = 'U7'
}
